<mat-form-field appearance="fill">
  @if (label()) {
    <mat-label>{{label()}}</mat-label>
  }
  <textarea matInput placeholder="{{placeholder()}}" rows="{{rows()}}"  [formControl]="control"></textarea>

  @if (showError && control.hasError('required')) {
    <mat-error [id]="''">Required</mat-error>
  }
  @if (control.hasError('message')) {
    <mat-error [id]="''">{{ control.getError('message') }}</mat-error>
  }
</mat-form-field>